<template>
    <div class="account">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>banner图</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 1rem; padding: 1rem; background-color: white">

            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/banner/create')" size="small">新建banner</el-button>
            <el-table
                    :data="banners"
                    style="width: 100%">
                <el-table-column
                        prop="url"
                        label="图片"
                >
                    <template slot-scope="scope">
                        <img :src="scope.row.url" width="100px">
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="sort"
                        label="排序"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="creator"
                        label="创建人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updator"
                        label="更新人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updateTime"
                        label="更新时间"
                >
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/banner/edit?id=' + scope.row.id)" type="text" size="small">编辑</el-button>
                        <!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
                        <el-button @click="deleteDevice(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import bannerApi from "../../api/banner.js";
    export default {
        data: function () {
            return {
                banners: [],
                page: 1,
                pageSize: 20,
                query: {}
            }
        },
        mounted() {
            this.loadAccounts();
        },
        methods: {
            loadAccounts: function () {
                bannerApi.getAll().then(accounts => {
                    this.banners = accounts;
                })
            },
            onQuery: function () {

            },
            deleteDevice: function(id) {
                this.$confirm('确定删除该账户？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    bannerApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadAccounts();
                    })
                });
            },
        }
    }
</script>
